<template>
    <div v-if="projeto" class="modal-overlay" @click="$emit('fechar')">
        <div class="modal-conteudo" @click.stop>
            <div class="modal-header">
                <h3>Detalhes do Projeto: {{ projeto.nome }}</h3>
                <button class="btn-fechar-modal" @click="$emit('fechar')">×</button>
            </div>
            <div class="modal-body">
                <div class="detalhes-grid">
                    <div class="detalhe-item">
                        <strong>Status:</strong>
                        <span class="chip" :class="getStatusClass(projeto.status)">{{ projeto.status }}</span>
                    </div>
                    <div class="detalhe-item">
                        <strong>Gerente:</strong> {{ projeto.gerente?.name ?? '-' }}
                    </div>
                    <div class="detalhe-item">
                        <strong>Assessor:</strong> {{ projeto.assessor?.name ?? '-' }}
                    </div>
                    <div class="detalhe-item">
                        <strong>Setor:</strong> {{ projeto.setor?.nome ?? '-' }}
                    </div>
                    <div class="detalhe-item">
                        <strong>Data Início:</strong> {{ formatarData(projeto.pcm?.dtInicio || projeto.dtInicio) }}
                    </div>
                    <div class="detalhe-item">
                        <strong>Fim Previsto:</strong> {{ formatarData(projeto.pcm?.dtEstimadaFinal) }}
                    </div>
                    <div class="detalhe-item">
                        <strong>Custo Total:</strong>
                        <span>{{ formatarMoeda(projeto.custo_total) }}</span>
                    </div>
                </div>

                <h4>Estatísticas de Tarefas</h4>
                <div class="estatisticas-grid">
                    <div class="estatistica-card">
                        <div class="estatistica-label">Total</div>
                        <div class="estatistica-valor">{{ projeto.estatisticas?.tarefas?.total ?? 0 }}</div>
                    </div>
                    <div class="estatistica-card">
                        <div class="estatistica-label">Pendentes</div>
                        <div class="estatistica-valor">{{ projeto.estatisticas?.tarefas?.pendentes ?? 0 }}</div>
                    </div>
                    <div class="estatistica-card">
                        <div class="estatistica-label">Em Andamento</div>
                        <div class="estatistica-valor">{{ projeto.estatisticas?.tarefas?.em_andamento ?? 0 }}</div>
                    </div>
                    <div class="estatistica-card">
                        <div class="estatistica-label">Concluídas</div>
                        <div class="estatistica-valor txt-sucesso">{{ projeto.estatisticas?.tarefas?.concluidas ?? 0 }}</div>
                    </div>
                    <div class="estatistica-card">
                        <div class="estatistica-label">Atrasadas</div>
                        <div class="estatistica-valor txt-erro">{{ projeto.estatisticas?.tarefas?.atrasadas ?? 0 }}</div>
                    </div>
                    <div class="estatistica-card">
                        <div class="estatistica-label">% Concluídas</div>
                        <div class="estatistica-valor">{{ projeto.estatisticas?.tarefas?.porcentagem_concluidas ?? 0 }}%</div>
                    </div>
                </div>

                <h4>Estatísticas de Horas (HP)</h4>
                <div class="estatisticas-grid">
                    <div class="estatistica-card">
                        <div class="estatistica-label">Total</div>
                        <div class="estatistica-valor">{{ projeto.estatisticas?.hp?.total ?? 0 }}h</div>
                    </div>
                    <div class="estatistica-card">
                        <div class="estatistica-label">Pendente</div>
                        <div class="estatistica-valor">{{ projeto.estatisticas?.hp?.pendente ?? 0 }}h</div>
                    </div>
                    <div class="estatistica-card">
                        <div class="estatistica-label">Em Andamento</div>
                        <div class="estatistica-valor">{{ projeto.estatisticas?.hp?.em_andamento ?? 0 }}h</div>
                    </div>
                    <div class="estatistica-card">
                        <div class="estatistica-label">Concluído</div>
                        <div class="estatistica-valor txt-sucesso">{{ projeto.estatisticas?.hp?.concluido ?? 0 }}h</div>
                    </div>
                    <div class="estatistica-card">
                        <div class="estatistica-label">% Concluído</div>
                        <div class="estatistica-valor">{{ projeto.estatisticas?.hp?.porcentagem_concluido ?? 0 }}%</div>
                    </div>
                </div>

                <h4>Pacotes de trabalho ({{ projeto.entregas?.length ?? 0 }})</h4>
                <div v-if="projeto.entregas?.length > 0" class="entregas-lista">
                    <div v-for="e in projeto.entregas" :key="e.id" class="entrega-card">
                        <div class="entrega-header">
                            <strong>{{ e.nome }}</strong>
                            <span class="chip" :class="getStatusClass(e.status)">{{ e.status }}</span>
                        </div>
                        <div class="entrega-body">
                            <div><strong>Coordenador:</strong> {{ e.coordenador?.name ?? '-' }}</div>
                            <div><strong>Período:</strong> {{ formatarData(e.dtInicio) }} a {{ formatarData(e.dtFim) }}</div>
                            <div class="estatisticas-pequenas">
                                <span>Tarefas: {{ e.estatisticas?.tarefas_concluidas ?? 0 }}/{{ e.estatisticas?.total_tarefas ?? 0 }}</span>
                                <span>Progresso: {{ e.estatisticas?.porcentagem_concluidas ?? 0 }}%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="sem-dados">Nenhum pacote de trabalho cadastrado</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalDetalhesProjeto',
    props: {
        projeto: {
            type: Object,
            default: null
        }
    },
    emits: ['fechar'],
    methods: {
        formatarMoeda(valor) {
            if (!valor) return 'R$ 0,00';
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
        },
        formatarData(data) {
            if (!data) return '-';
            return new Date(data).toLocaleDateString('pt-BR');
        },
        getStatusClass(status) {
            if (!status) return '';
            const statusLower = status.toLowerCase();
            if (statusLower.includes('concluído') || statusLower.includes('concluido')) return 'bg-sucesso';
            if (statusLower.includes('andamento')) return 'bg-info';
            if (statusLower.includes('pendente')) return 'bg-alerta';
            if (statusLower.includes('cancelado') || statusLower.includes('cancelada')) return 'bg-secundario';
            return '';
        }
    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 2rem;
}

.modal-conteudo {
    background: white;
    border-radius: 8px;
    max-width: 800px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-bottom: 1px solid #eee;
}

.modal-header h3 {
    margin: 0;
}

.btn-fechar-modal {
    background: none;
    border: none;
    font-size: 2rem;
    cursor: pointer;
    color: #999;
    line-height: 1;
    padding: 0;
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-fechar-modal:hover {
    color: #333;
}

.modal-body {
    padding: 1.5rem;
}

.detalhes-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    margin-bottom: 2rem;
}

.detalhe-item {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.estatisticas-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1rem;
    margin-bottom: 2rem;
}

.estatistica-card {
    background: #f8f9fa;
    padding: 1rem;
    border-radius: 6px;
    text-align: center;
}

.estatistica-label {
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 0.5rem;
}

.estatistica-valor {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
}

.entregas-lista {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.entrega-card {
    background: #f8f9fa;
    padding: 1rem;
    border-radius: 6px;
    border-left: 4px solid var(--cor-primaria, #3697d3);
}

.entrega-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
}

.entrega-body {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    font-size: 0.9rem;
}

.estatisticas-pequenas {
    display: flex;
    gap: 1rem;
    margin-top: 0.5rem;
}

.sem-dados {
    text-align: center;
    color: #999;
    padding: 2rem;
}
</style>

